import React, { useId, useState } from 'react';

import {
    IconArrowDown,
    IconArrowUp
} from '$partials/icon/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').Accordion}
 */
const Accordion = ({
    heading,
    label,
    modulePaddingClasses = '',
    rows
}) => {
    const panelIdPrefix = useId();

    const [openRows, setOpenRows] = useState(() => (rows?.length ? [rows[0].id] : []));

    const toggleRow = (id) => {
        setOpenRows((open) => {
            if (open.includes(id)) {
                return open.filter((openId) => openId !== id);
            }

            return [...open, id];
        });
    };

    return (
        <section className='module-accordion'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid flex-col sm:flex-row gap-y-10 sm:gap-y-0'>
                    <div className='sm:w-4/12 md:w-3/12 layout-grid-col'>
                        {label && (
                            <h2 className='type-style-heading'>{label}</h2>
                        )}
                    </div>

                    <div className='flex flex-col gap-y-16 sm:gap-y-32 sm:w-8/12 md:w-9/12'>
                        {heading && (
                            <div className='w-full layout-grid-col'>
                                {label && (
                                    <p className='type-style-heading sm:w-5/8 md:5/9'>{heading}</p>
                                )}

                                {!label && (
                                    <h2 className='type-style-heading sm:w-5/8 md:4/9'>{heading}</h2>
                                )}
                            </div>
                        )}

                        {rows?.length > 0 && (
                            <div className='w-full layout-grid-col'>
                                {rows.map((row) => {
                                    const isOpen = openRows.includes(row.id);

                                    return (
                                        <div
                                            className='border-t border-neutral-400'
                                            key={row.id}>
                                            <h3>
                                                <button
                                                    aria-controls={`${panelIdPrefix}-${row.id}`}
                                                    aria-expanded={isOpen}
                                                    className='w-full flex items-start justify-between gap-x-8 py-10 sm:py-16 text-left cursor-pointer type-style-body-bold'
                                                    onClick={() => toggleRow(row.id)}
                                                    type='button'>
                                                    {row.heading}

                                                    <span className='shrink-0'>
                                                        <IconArrowDown
                                                            className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                                                            height={20}
                                                            width={20} />
                                                    </span>
                                                </button>
                                            </h3>

                                            <div
                                                hidden={!isOpen}
                                                id={`${panelIdPrefix}-${row.id}`}>
                                                {row.text && (
                                                    <div
                                                        className='rich-text type-style-body pb-10 sm:pb-20 sm:w-4/8 md:w-4/9'
                                                        dangerouslySetInnerHTML={{ __html: row.text }} />
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Accordion;
